import { createSelector } from 'reselect';
import { matches } from 'lodash';
import { DISCONTINUE_RULE } from '../../constants/measure';

const RCT_DISCONTINUE_RULE = DISCONTINUE_RULE.RCT;

export const getResultsById = (state) => state.byId;

export const getResultInfo = (state, resultId) => getResultsById(state)[resultId];

export const getResults = createSelector(
    getResultsById,
    (resultsById) => Object.keys(resultsById).map((id) => resultsById[id]),
);

export const findResultFor = (state, searchParams) => {
    const results = getResults(state);
    const matchingResults = results.filter(matches(searchParams));
    if (matchingResults.length <= 1) {
        return matchingResults && matchingResults[0];
    }
    return matchingResults;
};

export const getIsResultDataFetched = (state) => state.isDataFetched;

export const getIncorrectQuestionsCount = (state) => state.incorrectQuestionsCounter;

export const isDiscontinueIncorrectQuestionRule = createSelector(
    [getIncorrectQuestionsCount],
    (incorrectCount) => incorrectCount >= RCT_DISCONTINUE_RULE.incorrectQuestions,
);
